import styled from 'particles/themes/styled'
import React from 'react'
import { useSelector } from 'react-redux'
import { useNewTranslation } from 'hooks/index'
import Text, { TextColor } from 'particles/Text'

import Container from '../layout/Container'
import { theme } from '../../theme'
import { ROUTES } from '../Root'

import { selectSelectedCampaignUuid, selectSelectedTaskUuid } from 'state/review'
import { SUBMISSION_VIEW_ENUM } from 'state/submissions'
import Icon from 'components/Icon/Icon'
import { RectangleLinkButton } from 'particles/Button/RectangleButton'

const EmptyStateWrapper = styled(Container)`
    .back-btn {
        margin-top: 24px;
        pointer-events: all; // This is needed cos pointer-events are set as disabled for MUI Table overlays
    }
`

interface EmptyStateProps {
    key?: string
    width?: string
    title: string
    isLoading?: boolean
    body: any
    titleColor?: TextColor
    bodyColor?: TextColor
    isShowButton?: boolean
    customIcon?: JSX.Element
    backBtnType?: 'AllSubmissions' | 'PartipostsDashboard'
    mx?: string
    my?: string
    className?: string
    dataTestId?: string
}

const EmptyState: React.FC<EmptyStateProps> = ({
    width,
    title,
    isLoading = false,
    body,
    backBtnType,
    titleColor = 'primary',
    bodyColor = 'primary',
    isShowButton = true,
    customIcon = null,
    dataTestId,
    ...props
}) => {
    const [newT] = useNewTranslation()
    const selectedCampaignUuid = useSelector(selectSelectedCampaignUuid)
    const selectedTaskUuid = useSelector(selectSelectedTaskUuid)
    const backToAllSubmissionsUrl = `/submissions/review?campaign=${selectedCampaignUuid}&task=${selectedTaskUuid}&viewType=${SUBMISSION_VIEW_ENUM.BATCH_SUBMISSIONS}`
    if (isLoading) return null
    return (
        <EmptyStateWrapper
            mx="auto"
            width={width}
            sx={{ textAlign: '-webkit-center' }}
            data-testid={dataTestId}
            {...props}
            className="empty-state"
        >
            {customIcon ? customIcon : <Icon.EmptyState2Icon />}
            <Text color={titleColor} scale="H4" style={{ marginBottom: theme.spacing.xxs }}>
                {title}
            </Text>
            <Text color={bodyColor} scale="bodyM500" style={{ marginTop: theme.spacing.xxs }}>
                {body}
            </Text>
            {isShowButton && backBtnType && (
                <RectangleLinkButton
                    className="back-btn"
                    form="filled"
                    size="l"
                    label={
                        backBtnType === 'AllSubmissions'
                            ? newT('button.backToAllSubmissions', 'Go to All Submissions Page')
                            : newT('button.backToDashBoard', 'Back to Partiposts Dashboard')
                    }
                    to={backBtnType === 'AllSubmissions' ? backToAllSubmissionsUrl : ROUTES.SubmissionsDashboard}
                />
            )}
        </EmptyStateWrapper>
    )
}

export default EmptyState
